import { render, staticRenderFns } from "./NtapsBatchPrint.vue?vue&type=template&id=f997b1ea&"
import script from "./NtapsBatchPrint.vue?vue&type=script&lang=js&"
export * from "./NtapsBatchPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports